import { createSelector } from 'reselect';

const selectDbaPartnerAgencyMappings = (state: any) => state.dbaPartnerAgencyMappings;


export const selectDbaPartnerAgencyMappingsCurrentItem = createSelector([selectDbaPartnerAgencyMappings], (dbaPartnerAgencyMappings) => dbaPartnerAgencyMappings.current);

export const selectDbaPartnerAgencyMappingsListItems = createSelector([selectDbaPartnerAgencyMappings], (dbaPartnerAgencyMappings) => dbaPartnerAgencyMappings.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectDbaPartnerAgencyMappingsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDbaPartnerAgencyMappingsQueryItems = createSelector([selectDbaPartnerAgencyMappings], (dbaPartnerAgencyMappings) => dbaPartnerAgencyMappings.query);

export const selectDbaPartnerAgencyMappingsCreatedItem = createSelector([selectDbaPartnerAgencyMappings], (dbaPartnerAgencyMappings) => dbaPartnerAgencyMappings.create);

export const selectDbaPartnerAgencyMappingsUpdatedItem = createSelector([selectDbaPartnerAgencyMappings], (dbaPartnerAgencyMappings) => dbaPartnerAgencyMappings.update);

export const selectDbaPartnerAgencyMappingsReadItem = createSelector([selectDbaPartnerAgencyMappings], (dbaPartnerAgencyMappings) => dbaPartnerAgencyMappings.read);

export const selectDbaPartnerAgencyMappingsDeletedItem = createSelector([selectDbaPartnerAgencyMappings], (dbaPartnerAgencyMappings) => dbaPartnerAgencyMappings.delete);

export const selectDbaPartnerAgencyMappingsSearchedItems = createSelector([selectDbaPartnerAgencyMappings], (dbaPartnerAgencyMappings) => dbaPartnerAgencyMappings.search);

export const selectDbaPartnerAgencyMappingsItemsCount = createSelector([selectDbaPartnerAgencyMappings], (dbaPartnerAgencyMappings) => dbaPartnerAgencyMappings.count);

export const selectDbaPartnerAgencyMappingsItemsFilter = createSelector([selectDbaPartnerAgencyMappings], (dbaPartnerAgencyMappings) => dbaPartnerAgencyMappings.filter);